import React from 'react'
import AppRoutes from './AppRoutes'

const App = () => {
  return (
    <div>
      <AppRoutes/>
    </div>
  )
}

export default App
